import type { TestId } from '../recordTests';

/**
 * 가이드 카드의 그림 자리 — 덱은 여기에 gif를 넣기로 했는데 에셋이 아직 없다.
 *
 * 빈 회색 박스로 두면 "로딩 실패"로 읽히므로, 그 진단에서 **목소리가 그릴 선**을 손수
 * SVG로 그려 둔다: 길게 내기는 평평한 선, 저음·고음은 내려갔다 올라오는 선. 에셋이 오면
 * 이 컴포넌트만 갈아끼운다. 색은 전부 테마 토큰(hex 하드코딩 없음).
 */

/** 24×8 좌표계 위의 음정 선 — 진단마다 다른 모양이 곧 설명이다. */
const CURVE: Record<TestId, string> = {
  sustain: 'M2 4 H22',
  // 저음·고음은 진단이 갈라져 있으므로 선도 갈라진다 — 하나는 내려가고 하나는 올라간다.
  low: 'M2 3 C8 3 10 7 22 7',
  high: 'M2 6 C8 6 12 1.5 22 1.5',
  // 노래는 계단 — 정해진 음을 하나씩 짚어 올라간다(길게도, 끝까지도 아니다).
  song: 'M2 6 H6 V5 H10 V3.5 H14 V2.5 H18 V4 H22',
};

/** 선의 끝점 — 그 진단이 **도착하는** 높이다. */
const DOT_Y: Record<TestId, number> = {
  sustain: 4,
  low: 7,
  high: 1.5,
  song: 4,
};

export const GuideIllustration = ({ testId }: { testId: TestId }) => (
  // 배경·모서리는 **호출자(가이드 카드)가 갖는다** — 여기서도 상자를 그리면 시안의 카드
  // 하나가 화면에서는 상자 두 개로 겹쳐 보인다.
  <div className="flex w-full items-center justify-center">
    <svg
      viewBox="0 0 24 8"
      className="h-20 w-full max-w-[15rem]"
      role="presentation"
      aria-hidden="true"
    >
      {/* 기준선 — 노래하는 음높이의 축. */}
      <line
        x1="0"
        y1="4"
        x2="24"
        y2="4"
        stroke="hsl(var(--primary))"
        strokeOpacity="0.2"
        strokeWidth="0.15"
        strokeDasharray="0.6 0.6"
      />
      <path
        d={CURVE[testId]}
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <circle cx="22" cy={DOT_Y[testId]} r="0.7" fill="hsl(var(--primary))" />
    </svg>
  </div>
);
